import { gql } from '@apollo/client';
import React from 'react';
import type { PostOwnerSelect_PostFragment } from '../graphql/generated/graphqlTypes';
import EntitySelect from '../search/entitySearch/EntitySelect';
import type { userToEntity } from '../search/entitySearch/localEntitySearch';
import { useUpdatePostOwner } from './sharing/postPermissionOperations';

const POST_FRAGMENT = gql`
  fragment PostOwnerSelect_post on Post {
    id
    ...useUpdatePostOwner_post
  }
  ${useUpdatePostOwner.fragments.post}
`;

interface PostOwnerSelectProps {
  menuPlacement: React.ComponentProps<typeof EntitySelect>['menuPlacement'];
  onChange: (newOwner: { id: string }) => unknown;
  owner: Parameters<typeof userToEntity>[0];
  post: PostOwnerSelect_PostFragment;
}

const SEARCH_CONFIG = { user: {} };

const PostOwnerSelect = ({
  menuPlacement,
  onChange,
  owner,
  post,
}: PostOwnerSelectProps) => {
  const updateOwner = useUpdatePostOwner();

  return (
    <EntitySelect
      autoFocus
      isClearable={false}
      onChange={(result) => {
        if (result?.type !== 'user') return;
        const { user } = result;
        updateOwner(post, user);
        onChange(user);
      }}
      value={{ type: 'user', id: owner.id }}
      config={SEARCH_CONFIG}
      menuPlacement={menuPlacement}
    />
  );
};

PostOwnerSelect.fragments = {
  post: POST_FRAGMENT,
};

export default PostOwnerSelect;
